import { createListAtoms } from "../../common/DataList";

// ============================================================
// Liste des utilisateurs — configuration pure (testable sans DOM) : filtres
// par défaut, définitions du panneau, construction de la requête
// POST managers/search { user: { searchString, role }, page, nbItemsByPage }.
// La recherche reste automatique (débounce de 800 ms), comme l'écran
// historique ; la dernière recherche est mémorisée entre deux visites.
// ============================================================

export const USERS_ENDPOINT = "managers/search";
export const DELAI_RECHERCHE = 800;
export const USERS_DEFAULT_FILTERS = { terms: "", role: "", operator: "" };
export const USERS_PERSIST_KEY = "espoar.boa.userList.search";

export const usersAtoms = createListAtoms({
  defaultFilters: USERS_DEFAULT_FILTERS,
  persistKey: USERS_PERSIST_KEY,
});

export const GROUPES_FILTRES_UTILISATEURS = [{ id: "compte", title: "Compte" }];

// Le rôle est dans la barre de recherche ; la structure d'un compte
// d'opérateur (CE-1407) attend dans le panneau, une fois les opérateurs
// d'accompagnement connus (`operateurs` : [{ id, name }]).
export const definitionsFiltresUtilisateurs = (roles = [], operateurs = []) => [
  {
    name: "role",
    group: "compte",
    label: "Rôle",
    type: "select",
    principal: true,
    firstOptionLabel: "Tous les rôles",
    options: roles,
  },
  ...(operateurs.length
    ? [
        {
          name: "operator",
          group: "compte",
          label: "Structure",
          type: "select",
          firstOptionLabel: "Toutes les structures",
          options: operateurs,
        },
      ]
    : []),
];

export function buildUsersPayload(search) {
  const filters = (search && search.filters) || {};
  const user = {
    searchString: String(filters.terms || "").trim(),
    role: filters.role || "",
  };
  // Absente, la clé ne filtre pas : une chaîne vide filtrerait sur « sans structure ».
  if (filters.operator) user.operator = filters.operator;
  return {
    user,
    page: Number(search && search.page) || 1,
    nbItemsByPage: Number(search && search.nbItemsByPage) || 25,
  };
}

export function nomStructure(id, operateurs = []) {
  if (!id) return "";
  const trouve = operateurs.find((o) => o.id === id);
  return trouve ? trouve.name : "";
}

// Opérateurs d'accompagnement sous la forme { id, name } des sélecteurs.
export const operateursPourSelecteur = (reponse) =>
  (((reponse && reponse.donnees) || [])).map((o) => ({ id: o.id, name: o.nom }));

// « Toutes » quand l'utilisateur est rattaché à toutes les organisations
// connues, sinon la liste de leurs noms (règle de l'écran historique, qui
// comparait les longueurs ; on vérifie ici l'appartenance).
export function nomsOrganisations(ids = [], organizations = []) {
  if (!organizations.length || !Array.isArray(ids) || !ids.length) return "";
  if (organizations.every((o) => ids.includes(o.id))) return "Toutes";
  return organizations
    .filter((o) => ids.includes(o.id))
    .map((o) => o.name)
    .join(", ");
}
